module.exports = __webpack_public_path__ + "assets/img/swiper-3.2e3caadd.jpg";